import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import Buefy from 'buefy'
import VueApexCharts from 'vue-apexcharts'

Vue.prototype.$http = Axios;
Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
